// extracted by mini-css-extract-plugin
export var body = "_dy-0";
export var sectionHeader = "_dy-4";
export var shortcutColumns = "_dy-2";
export var shortcutList = "_dy-1";
export var shortcutSection = "_dy-3";